import PropTypes from 'prop-types';
import React from 'react';

import { ADMIN_FEATURE_PATHS } from '../../../commons/utils/featurePaths';
import { ENUM_MODULE_NAME } from '../../../commons/utils/features';

import { ModuleContainer } from '../../ModuleContainer';

export const AdminCatalogsContainer = (props) => {
  const { userRights, history } = props;

  return (
    <ModuleContainer
      history={history}
      moduleFeaturePaths={[ADMIN_FEATURE_PATHS.ADMIN_CATALOGS]}
      moduleName={ENUM_MODULE_NAME.ADMIN}
      userRights={userRights}
    />
  );
};

AdminCatalogsContainer.propTypes = {
  userRights: PropTypes.array,
  history: PropTypes.any, // react-router-dom's route prop
  moduleName: PropTypes.oneOf(Object.values(ENUM_MODULE_NAME)),
  moduleFeaturePaths: PropTypes.arrayOf(PropTypes.string),
};

// ===== Module features for easy import in ClientContainer =====

import CatalogCreation from './components/Creation';
import CatalogDetails from './components/Details';
import Catalogs from './components/Catalogs';
import CatalogUsers from './components/Users';

const AdminCatalogsModule = {
  AdminCatalogsContainer,
  Catalogs,
  CatalogCreation,
  CatalogDetails,
  CatalogUsers,
};

export default AdminCatalogsModule;
